module.exports = __webpack_public_path__ + "static/phone-781daf74d00b461363956eff7b5f9546.png";